import {
	domainWithoutWWW,
	domainWithWWW,
	formatAsCustomDomain,
	getDomainNamePublicSuffix,
	removePublicSuffixFromDomainName,
} from './parse';
import { getIsSubDomain } from './validation';

export interface DomainDetails {
	domainName: string;
	rootDomain: string;
	publicSuffix: string;
	withoutPublicSuffix: string;
	isSubdomain: boolean;
	withWww: string;
	withoutWww: string;
	rootDomainPart: string;
	subdomainPart: string | undefined;
	formattedDomainName: string;
}

export const getDomainDetails = async (domainName: string): Promise<DomainDetails> => {
	const { default: publicSuffixList } = await import(
		'common/services/publicSuffixList/public-suffix.json'
	);
	const publicSuffix = getDomainNamePublicSuffix(domainName, publicSuffixList);
	const withoutPublicSuffix = removePublicSuffixFromDomainName(domainName, publicSuffix);
	const isSubdomain = await getIsSubDomain(domainName);
	const domainWithoutPublicSuffixAndWww = domainWithoutWWW(withoutPublicSuffix);
	const domainParts = domainWithoutPublicSuffixAndWww.split('.');
	const rootDomainPart = domainParts[domainParts.length - 1] ?? domainWithoutPublicSuffixAndWww;
	const subdomainPart =
		domainParts.length > 1 ? domainParts.slice(0, domainParts.length - 1).join('.') : undefined;
	const formattedDomainName = await formatAsCustomDomain(domainName);
	const withoutWww = domainWithoutWWW(domainName);
	const rootDomain = !subdomainPart ? withoutWww : withoutWww.replace(`${subdomainPart}.`, '');
	return {
		domainName,
		publicSuffix: publicSuffix,
		withoutPublicSuffix,
		isSubdomain,
		rootDomainPart,
		subdomainPart,
		withWww: domainWithWWW(domainName),
		withoutWww,
		formattedDomainName,
		rootDomain,
	};
};
